import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    q: 'Voor welke groepen is Meester djay geschikt?',
    a: 'Meester djay is ontworpen voor groep 6, 7 en 8 van het Nederlandse basisonderwijs. Uitbreiding naar groep 3-5 staat op de roadmap.'
  }, {
    q: 'Hoe past het systeem zich aan het niveau van mijn kind aan?',
    a: 'Het adaptieve systeem meet continu de beheersing per skill. Wie iets goed begrijpt krijgt automatisch moeilijkere vragen. Wie moeite heeft krijgt vragen op een lager niveau, met extra visuele hulp en uitleg.'
  }, {
    q: 'Welke vakken worden aangeboden?',
    a: 'Tien vakgebieden: Rekenen, Getallen, Meten & Omrekenen, Tijd, Geld, Werkwoordspelling, Spelling & Grammatica, Taalbegrip & Lezen, Studievaardigheden en Topografie.'
  }, {
    q: 'Hoe kan ik als ouder de voortgang volgen?',
    a: 'Via het ouderportaal zie je per kind de voortgang per vak, weekoverzichten, prestaties en tips. Je kunt eenvoudig schakelen tussen meerdere kinderen.'
  }, {
    q: 'Hoe kan ik als leraar Meester djay in de klas gebruiken?',
    a: 'Het lerarenportaal biedt een klasoverzicht met gemiddelde beheersing per vak, signalering van leerlingen die extra aandacht nodig hebben, en weekinzichten over oefenactiviteit.'
  }, {
    q: 'Is er een toetsfunctie?',
    a: 'Ja, Meester djay biedt Cito-achtige toetsen met 30 vragen en een tijdslimiet. Na afloop ontvang je een gedetailleerd leerlingprofiel met geschat niveau per vak, groei-indicatoren en een actieplan.'
  }, {
    q: 'Hoe wordt de kwaliteit van vragen gewaarborgd?',
    a: 'Elke vraag doorloopt een geautomatiseerde 6-staps kwaliteitspipeline die schema, vraagtype, inhoud, visuele hulpmiddelen, hints en leerpad-afhankelijkheden controleert. Vragen die niet slagen worden automatisch geblokkeerd.'
  }, {
    q: 'Is Meester djay gratis?',
    a: 'De demo is gratis beschikbaar. Neem contact op voor informatie over schoollicenties en prijzen.'
  }];
  return <section id="faq" className="py-16 lg:py-24 bg-[#fffbf5]" data-id="element-1">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2">
        <div className="text-left mb-12" data-id="element-3">
          <h2 className="text-3xl md:text-4xl font-extrabold text-slate-950 mb-4 tracking-tighter" data-id="element-4">
            Veelgestelde Vragen 💡
          </h2>
          <p className="text-lg text-slate-600" data-id="element-5">
            Alles wat je moet weten over het platform, de adaptiviteit en de
            inzetbaarheid.
          </p>
        </div>

        <div className="space-y-3" data-id="element-6">
          {faqs.map((faq, index) => <div key={index} className="bg-white border border-slate-200 rounded-xl overflow-hidden shadow-sm hover:shadow-md transition-shadow" data-id="element-7">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none hover:bg-orange-50/50 transition-colors" aria-expanded={openIndex === index} data-id="element-8">
                <span className="font-bold text-slate-950 pr-8 text-base" data-id="element-9">
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-orange-500 shrink-0 transition-transform duration-200 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-10" />
              </button>

              <AnimatePresence data-id="element-11">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.2,
              ease: 'easeInOut'
            }} data-id="element-12">
                    <div className="px-6 pb-5 pt-0 text-slate-600 text-base leading-relaxed" data-id="element-13">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}